import { render } from "./SettledCredits.vue?vue&type=template&id=2e78f720"
import script from "./SettledCredits.vue?vue&type=script&lang=js"
export * from "./SettledCredits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__